import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {EyeOff, Eye, Check, Circle} from 'lucide-react'
import logoKP from '../img/keenpoint-logo-horizontal.png'
import logoCNDA from '../img/logo_cnda2.png'
/*
import logoRTE from '../img/logo_RTE.png'
import logoHermes from '../img/logo_Hermes.png'
import logoEDF from '../img/logo_EDF.png'
import logoCELIO from '../img/logo_CELIO.png'
import logoUAPL from '../img/logo_uapl.png'
import logoCSE from '../img/logo_mycsemanco.png'
 */
import { toastr } from 'react-redux-toastr'
import './login.css'
import {WarningBanner} from './Banner'
import { STRONG_PASS, MEDIUM_PASS, WEAK_PASS } from '../utils/regExps'
import SpinningDots from "./Loader/SpinningDots";
import DynamicStyledInput from "./Form/DynamicStyledInput";

// keep in sync with STRONG_PASS in src/utils/regExps.js
const SPECIAL_CHARS = '! @ # $ % ^ & * ( ) _ + - = [ ] { } ; : , . ? /'

const getLogo = (client) => {
    switch (client) {
        case 'cnda':
            return logoCNDA
        default:
            return logoKP
    }
}

const getLogoStyle = (client) => {
    switch (client) {
        case 'cnda':
            return {height: '200px'}
        default:
            return {width: '200px'}
    }
}

class Reset extends Component {
    constructor() {
        super()

        this.state = {
            password: '',
            passwordConfirmation: '',
            showPass: false,
            showPassConf: false,
            score: 0
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.passwordStrength = this.passwordStrength.bind(this)
    }

    handleChange(field, event) {
        const newValue = event.target.value
        this.setState({
            [field]: newValue
        })
        if(field === 'password') {
            this.passwordStrength(event)
        }
    }

    passwordStrength(e){
        const pwd = e.target.value

        const strongRegex = new RegExp(STRONG_PASS, "g")
        const mediumRegex = new RegExp(MEDIUM_PASS, "g")
        const enoughRegex = new RegExp(WEAK_PASS, "g")

        if(strongRegex.test(pwd)) {
            this.setState({score: 3})
        } else if(mediumRegex.test(pwd)){
            this.setState({score: 2})
        } else if(enoughRegex.test(pwd)) {
            this.setState({score: 1})
        } else this.setState({score: 0})
    }

    handleSubmit(event) {
        event.preventDefault()
        const { handleSubmit, t } = this.props
        if (!this.state.password) {
            toastr.error(
                t('error'),
                t("notEmptyPasswordField")
            )
        } else if (this.state.score < 3) {
            toastr.error(
                t('error'),
                t("weakPassword")
            )
        } else if (this.state.password === this.state.passwordConfirmation) {
            handleSubmit && handleSubmit(this.state.password)
        } else {
            toastr.error(
                t('error'),
                t("passwordConfirmationDoesNotMatchPassword")
            )
        }
    }

    render() {
        const {error, t, loading, client} = this.props
        const password = this.state.password
        const passwordRules = [
            {key: 'passwordRule14Chars', valid: password.length >= 14},
            {key: 'passwordRuleUppercase', valid: /[A-Z]/.test(password)},
            {key: 'passwordRuleLowercase', valid: /[a-z]/.test(password)},
            {key: 'passwordRuleDigit', valid: /[0-9]/.test(password)},
            {key: 'passwordRuleSpecial', valid: /[!@#$%^&*()_+\-=[\]{};:,.?/]/.test(password), data: {chars: SPECIAL_CHARS}}
        ]
        return (
            <div className="Login-container">
                <div className="Login-form-container">
                    <div className="Login-logo-container">
                        <img
                            alt="Login-logo"
                            src={getLogo(client)}
                            style={getLogoStyle(client)}
                        />
                    </div>
                    <div className= "Login-well">
                        {
                            loading
                                ? <SpinningDots/>
                                : error
                                    ? <WarningBanner message={t(error)}/>
                                    : (
                                        <form onSubmit={this.handleSubmit}>
                                            <div style={{textAlign: 'left', margin: "20px 0 8px", fontSize: '1.15em', fontWeight: 600}}>
                                                {t('enterNewPassword')}
                                            </div>
                                            <div style={{textAlign: 'left', margin: "0 0 15px", fontSize: '0.85em', color: '#525252'}}>
                                                {t('passwordRequirements')}
                                                <ul style={{listStyle: 'none', padding: 0, margin: '6px 0 0'}}>
                                                    {passwordRules.map(rule => (
                                                        <li
                                                            key={rule.key}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                margin: '3px 0',
                                                                color: rule.valid ? '#53a552' : '#a0a0a0'
                                                            }}
                                                        >
                                                            {
                                                                rule.valid
                                                                    ? <Check size={14} style={{marginRight: 6, flexShrink: 0}}/>
                                                                    : <Circle size={14} style={{marginRight: 6, flexShrink: 0}}/>
                                                            }
                                                            {t(rule.key, rule.data)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <div style={{position: 'relative'}}>
                                                <DynamicStyledInput
                                                    id="ResetForm-password"
                                                    path="newPassword"
                                                    type={this.state.showPass ? "text" : "password"}
                                                    value={this.state.password}
                                                    onChange={event => this.handleChange("password", event)}
                                                    t={t}
                                                />
                                                <span onClick={() => this.setState({showPass: !this.state.showPass})}
                                                      className="Login-eye-icon">
                                                {
                                                    this.state.showPass
                                                        ? <EyeOff size={17}/>
                                                        : <Eye size={17}/>
                                                }
                                            </span>
                                            </div>
                                            <br/>
                                            <div style={{position: 'relative'}}>
                                                <DynamicStyledInput
                                                    id="ResetForm-passwordConfirmation"
                                                    path="newPasswordConfirmation"
                                                    type={this.state.showPassConf ? "text" : "password"}
                                                    value={this.state.passwordConfirmation}
                                                    onChange={event => this.handleChange("passwordConfirmation", event)}
                                                    t={t}
                                                />
                                                <span
                                                    onClick={() => this.setState({showPassConf: !this.state.showPassConf})}
                                                    className="Login-eye-icon">
                                                {
                                                    this.state.showPassConf
                                                        ? <EyeOff size={17}/>
                                                        : <Eye size={17}/>
                                                }
                                            </span>
                                            </div>
                                            <br/>
                                            <div className='Login-buttons'>
                                                <button type="submit" className="btn Reset-pass-submit-button"
                                                        value="submit">
                                                    {t("saveNewPassword")}
                                                </button>
                                            </div>
                                        </form>
                                    )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

Reset.propTypes = {
    handleSubmit: PropTypes.func.isRequired
}

export default Reset

